import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export function TableLoadingOverlay() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
      }}
    >
      <CircularProgress />
    </Box>
  );
}
